const formatCamelCase = (text: string): string => text
  .replace(/([A-Z])/g, ' $1')
  .replace(/^./, (str) => str.toUpperCase())
  .trim();

export default formatCamelCase;

export const formatTextTitle = (text: string, capitalizeFirstLetter = true): string => {
  if (text === 'requires-rework') {
    return 'Requires re-work';
  }
  const words = text
    .replace(/([A-Z])/g, ' $1')
    .split(/[_-\s]+/)
    .filter((word) => word.length > 0)
    .map((word) => word.toLowerCase());

  if (capitalizeFirstLetter) {
    return words
      .map((word, index) => (index === 0
        ? word.charAt(0).toUpperCase() + word.slice(1)
        : word))
      .join(' ')
      .trim();
  }

  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
    .trim();
};

interface IDiffResult {
  text: string,
  isDifferent: boolean,
}

export const findCommonSuffix = (str1: string = '', str2: string = ''): number => {
  const reversed1 = str1.split('').reverse();
  const reversed2 = str2.split('').reverse();

  return reversed1.reduce((count, char, index) => {
    if (index < str2.length && char === reversed2[index]) {
      return count + 1;
    }
    return count;
  }, 0);
};

export const compareStrings = (value: string = '', otherValue: string = ''): IDiffResult[] => {
  const result: IDiffResult[] = [];
  const commonSuffixLength = findCommonSuffix(value, otherValue);
  if (value.length === 0) {
    return [{ text: '', isDifferent: false }];
  }
  if (value.length - commonSuffixLength > 0) {
    result.push({
      text: value.slice(0, value.length - commonSuffixLength),
      isDifferent: true,
    });
  }
  if (commonSuffixLength > 0) {
    result.push({
      text: value.slice(value.length - commonSuffixLength),
      isDifferent: false,
    });
  }
  return result;
};

export const decodeHTML = (html: string): string => {
  if (!html || typeof html !== 'string') return '';
  const textarea = document.createElement('textarea');
  textarea.innerHTML = html;
  let decoded = textarea.value;
  if (decoded === html) {
    decoded = html
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&#39;/g, "'")
      .replace(/&#x27;/g, "'")
      .replace(/&#x2F;/g, '/')
      .replace(/&#x60;/g, '`')
      .replace(/&#x3D;/g, '=');
  }
  return decoded;
};

export const capitalizeFirstLetter = (word: string): string => {
  if (word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  return '';
};

export const formatStringToCamelCase = (text: string): string => {
  if (!text) return '';

  return text
    .split(/[-_\s]+/)
    .filter((word) => word.length > 0)
    .map((word, index) => {
      const lowerWord = word.toLowerCase();
      if (index === 0) {
        return lowerWord;
      }
      return lowerWord.charAt(0).toUpperCase() + lowerWord.slice(1);
    })
    .join('');
};

export const parseValuesString = (values: string | undefined): string[] => {
  if (!values || typeof values !== 'string') return [];
  const parsed = JSON.parse(`[${values}]`);
  if (Array.isArray(parsed) && parsed.every((x) => typeof x === 'string')) {
    return parsed;
  }
  return values
    .split('", "')
    .map((v) => v.replace(/(^["\\]+)|(["\\]+$)/g, '').trim())
    .filter(Boolean);
};
